import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import TextArea from 'modules/core/components/Inputs/TextArea'
import validateNumberInput from 'modules/core/lib/validateNumberInput'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import RatingInput from 'modules/surveys/components/RatingInput'

import Select from './Select'

const DEFAULT_RATING_MIN = 0
const DEFAULT_RATING_MAX = 10

interface Props {
  mandatory: boolean
  formField: Field
  fieldType: string
  readonly?: boolean
  minValue?: number
  maxValue?: number
  options: Array<{ value: string; label: string }>
}

function InputItem({
  options,
  mandatory,
  formField,
  fieldType,
  minValue,
  maxValue,
  readonly,
}: Props) {
  const onClick = (value: string | number) => formField.set(value)

  switch (fieldType) {
    case FieldTypes.rating:
      return (
        <RatingInput
          max={maxValue || DEFAULT_RATING_MAX}
          min={minValue || DEFAULT_RATING_MIN}
          onClick={onClick}
          readonly={readonly}
          value={formField.value}
          mandatory={Boolean(mandatory && formField.value.length === 0)}
        />
      )

    case FieldTypes.singleChoice:
      return (
        <Select
          options={options}
          value={formField.value}
          onClick={onClick}
          mandatory={mandatory}
          readonly={!!readonly}
        />
      )

    case FieldTypes.cents:
      return (
        <Text
          mandatory={mandatory}
          field={formField}
          readonly={readonly}
          validation={validateNumberInput}
        />
      )

    default:
      return <TextArea mandatory={mandatory} field={formField} readonly={readonly} />
  }
}

export default observer(InputItem)
